import { REPORT_TYPES, GRAPH_DATATYPE, QUALITATIVE_REPORT_LEVELS } from "../../../constants/app-constant";
//import { newFormatDataBySOV } from "./new-format-data-by-ranking";
//import { formatDataByTonality } from "./format-data-by-tonality";
//import { newFormatDataByTrend } from "./new-format-data-by-trend";
import { getRandomUniqueColor, getLineGraphFormat } from "./format-utils";
import {
    VERTICALS,
    GRAPH_TYPES,
    CONSTANTS,
} from "../../../constants/app-constant";
import { QUALITATIVE_CHART_TYPE_FILTERS } from "../../../constants/static-filter";

const { PIE, TABLE, BAR_STACKED_EQUAL_HEIGHT, LINE, BAR_VERTICAL } = GRAPH_TYPES;
const {
    REPORTS: { TYPES },
} = CONSTANTS;

const {
    ENTITY,
    KEYWORD,
    JOURNALIST,
    CITY,
    PUBLICATION,
} = QUALITATIVE_REPORT_LEVELS;

const {
    SentimentEntityTrendCCM,
    SentimentEntityTrendIndex,
    SentimentEntityTrendNOA,
    SentimentEntityTrendReach,
    SentimentEntityTrendMAV,
    SentimentEntityTrendWordCount,

    SentimentJournalistTrendCCM,
    SentimentJournalistTrendIndex,
    SentimentJournalistTrendNOA,
    SentimentJournalistTrendReach,
    SentimentJournalistTrendMAV,
    SentimentJournalistTrendWordCount,

    SentimentKeywordTrendCCM,
    SentimentKeywordTrendIndex,
    SentimentKeywordTrendNOA,
    SentimentKeywordTrendReach,
    SentimentKeywordTrendMAV,
    SentimentKeywordTrendWordCount,


    SentimentPublicationTrendCCM,
    SentimentPublicationTrendIndex,
    SentimentPublicationTrendNOA,
    SentimentPublicationTrendReach,
    SentimentPublicationTrendMAV,
    SentimentPublicationTrendWordCount,

    SentimentCityTrendCCM,
    SentimentCityTrendIndex,
    SentimentCityTrendNOA,
    SentimentCityTrendReach,
    SentimentCityTrendMAV,

} = REPORT_TYPES;

const {
    SentimentEntityTrendOnline,
    SentimentEntityTrendPrint,
    SentimentJournalistSOVOnline,
    SentimentJournalistSOVPrint,
    SentimentJournalistTrendOnline,
    SentimentJournalistTrendPrint,
    SentimentKeywordSOVOnline,
    SentimentKeywordSOVPrint,
    SentimentKeywordTrendOnline,
    SentimentKeywordTrendPrint,
    SentimentEntitySOVOnline,
    SentimentEntitySOVPrint,
    SentimentPublicationTrendOnline,
    SentimentPublicationTrendPrint,
    SentimentPublicationSOVOnline,
    SentimentPublicationSOVPrint,
    SentimentCityTrendPrint,
    SentimentCitySOVPrint,
    SentimentNewEntitySOVOnline,
    SentimentNewEntitySOVPrint,
} = GRAPH_DATATYPE;



export const newFormatDataBySentiment = (
    d = [],
    graph_type,
    report_type,
    selectedInlineSentiment,
    graphDataType,
    selectedInlineEntity,
) => {
    const { online, print } = graphDataType;
    const isEntityLevel =
        online === SentimentEntitySOVOnline ||
        print === SentimentEntitySOVPrint ||
        online === SentimentEntityTrendOnline ||
        print === SentimentEntityTrendPrint

    const isJournalistLevel =
        online === SentimentJournalistSOVOnline ||
        print === SentimentJournalistSOVPrint ||
        online === SentimentJournalistTrendOnline ||
        print === SentimentJournalistTrendPrint

    const isKeywordLevel =
        online === SentimentKeywordSOVOnline ||
        print === SentimentKeywordSOVPrint ||
        online === SentimentKeywordTrendOnline ||
        print === SentimentKeywordTrendPrint;

    //change as above
    const isPublicationLevel = online === SentimentPublicationSOVOnline ||
        print === SentimentPublicationSOVPrint ||
        online === SentimentPublicationTrendOnline ||
        print === SentimentPublicationTrendPrint;
    const isCityLevel =
        print === SentimentCitySOVPrint ||
        print === SentimentCityTrendPrint;

    const isNewEntityLevel =
        online === SentimentNewEntitySOVOnline ||
        print === SentimentNewEntitySOVPrint

    const level =
        (isEntityLevel) ? ENTITY :
            (isJournalistLevel) ? JOURNALIST :
                (isPublicationLevel) ? PUBLICATION :
                    (isCityLevel) ? CITY :
                        (isKeywordLevel) ? KEYWORD :
                            (isNewEntityLevel) ? "NewEntity" :
                                "No Level";

    const isTrend =
        report_type === SentimentEntityTrendCCM ||
        report_type === SentimentEntityTrendMAV ||
        report_type === SentimentEntityTrendNOA ||
        report_type === SentimentEntityTrendIndex ||
        report_type === SentimentEntityTrendWordCount ||
        report_type === SentimentEntityTrendReach ||
        report_type === SentimentJournalistTrendCCM ||
        report_type === SentimentJournalistTrendMAV ||
        report_type === SentimentJournalistTrendNOA ||
        report_type === SentimentJournalistTrendIndex ||
        report_type === SentimentJournalistTrendWordCount ||
        report_type === SentimentJournalistTrendReach ||
        report_type === SentimentKeywordTrendCCM ||
        report_type === SentimentKeywordTrendMAV ||
        report_type === SentimentKeywordTrendNOA ||
        report_type === SentimentKeywordTrendIndex ||
        report_type === SentimentKeywordTrendWordCount ||
        report_type === SentimentKeywordTrendReach ||
        report_type === SentimentPublicationTrendCCM ||
        report_type === SentimentPublicationTrendMAV ||
        report_type === SentimentPublicationTrendNOA ||
        report_type === SentimentPublicationTrendIndex ||
        report_type === SentimentPublicationTrendWordCount ||
        report_type === SentimentPublicationTrendReach ||
        report_type === SentimentCityTrendCCM ||
        report_type === SentimentCityTrendMAV ||
        report_type === SentimentCityTrendNOA ||
        report_type === SentimentCityTrendIndex ||
        report_type === SentimentCityTrendReach ||
        report_type === SentimentKeywordTrendCCM ||
        report_type === SentimentKeywordTrendMAV ||
        report_type === SentimentKeywordTrendNOA ||
        report_type === SentimentKeywordTrendIndex ||
        report_type === SentimentKeywordTrendWordCount ||
        report_type === SentimentKeywordTrendReach;



    const currentMeasure = (report_type) => {
        const measures = {
            NOA: "article_count",
            CCM: "ccmtotal",
            MAV: "mavtotal",
            Index: "indextotal",
            WC: "wordcounttotal",
            Reach: "reachtotal",
        };
        const noaRegex = /noa/i;
        const ccmRegex = /ccm/i;
        const mavRegex = /mav/i;
        const indexRegex = /index/i;
        const wordCountRegex = /wordCount/i;
        const reachRegex = /reach/i;
        if (noaRegex.test(report_type)) {
            return measures.NOA;
        } else if (ccmRegex.test(report_type)) {
            return measures.CCM;
        } else if (mavRegex.test(report_type)) {
            return measures.MAV;
        } else if (indexRegex.test(report_type)) {
            return measures.Index;
        } else if (wordCountRegex.test(report_type)) {
            return measures.WC;
        } else if (reachRegex.test(report_type)) {
            return measures.Reach;
        } else {
            console.log("No report name match found");
            return;
        }
    }
    const measure = currentMeasure(report_type);
    if (isTrend) {
        return newFormatDataByTrend(d, level, graph_type, measure, selectedInlineEntity.value, selectedInlineSentiment.value);
    }
    else {
        return newFormatDataBySOV(d, level, graph_type, measure, selectedInlineEntity.value, selectedInlineSentiment.value, selectedInlineSentiment.value);
    }
};

const newFormatDataBySOV = (d = [], level, graphType, currentMeasure, entity, sentiment) => {
    const result = d;
    const dataObj = result && result[result.sequence[0]].returnData
    const entities = dataObj.entities;
    const graphData = dataObj.graphdata;
    const color = entities && getRandomUniqueColor(entities.length);
    const datasets = [];
    const labels = [];
    const hcPieChartData = [];
    const lineTension = 0;
    const barThickness = "flex";
    const fill = false;
    const borderWidth = 1;
    const sentimentColors = {
        "Positive": "#079138",
        "Negative": "#bd1e06",
        "Informative": "#fca800",
    };
    if (level === 'NewEntity') {
        const sentiments = dataObj.tonality
        const colors = getRandomUniqueColor(sentiments.length);
        sentiments && sentiments.forEach((sentiment, idx) => {

            const label = sentiment;
            const backgroundColor = (sentimentColors[sentiment]) ? sentimentColors[sentiment] : colors[idx];
            const data = [];
            entities && entities.forEach(({ entity_name }) => {
                labels.push(entity_name);
                let currVal = 0;
                if (graphData[entity_name] &&
                    graphData[entity_name].hasOwnProperty(sentiment)) {
                    currVal = parseData(graphData[entity_name][sentiment][currentMeasure], true);
                }
                data.push(currVal);
            });
            datasets.push({ label, backgroundColor, data });
        });
        return { labels, datasets };
    }
    else if (level === ENTITY && level !== 'NewEntity') {
        const measure = currentMeasure;
        labels.push(sentiment);
        graphData[sentiment] !== undefined && Object.keys(graphData[sentiment]).forEach((currData, idx) => {
            const label = currData;
            const backgroundColor = color[idx];
            const borderColor = color[idx];
            const currVal = parseData(graphData[sentiment][currData][measure], true);
            const data = [currVal];
            datasets.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill, lineTension });
            hcPieChartData.push({ name: label, y: currVal, backgroundColor });
        });
        if (graphType === BAR_VERTICAL && graphData[sentiment]) {
            // console.log('labels, datasets bar', labels, datasets)

            return { labels, datasets };
        }
        else if (graphType === PIE && graphData[sentiment]) {
            // console.log('labels, datasets pie', labels, datasets)

            const entityNames = entities.map((ent) => ent.entity_name);
            return { labels: entityNames, datasets, hcPieChartData };
        }
        else {
            // console.log('labels, datasets empty', labels, datasets)

            return { labels: [], datasets: [], hcPieChartData: [{}] };
        }
    }
    else {
        const measure = currentMeasure;// currentMeasure === "wordcounttotal" ? "wordcnttotal" : currentMeasure === "index" ? "indexPerc" : currentMeasure;
        labels.push("Journalist");
        const entNames = entities && entities.map((ent) => ent.entity_name);
        const level2Keys = dataObj && Object.keys(graphData);
        const color = getRandomUniqueColor(level2Keys.length);
        const legendSet = [];
        const legendSetLength = Math.ceil(level2Keys.length / 10);
        for (let x = 1, y = 0; x <= 1; x++) {
            const pieSet = [];
            const set = [];
            level2Keys && level2Keys.filter((v, i) => (i >= y && i < (x * 10))).forEach((val, idx) => {
                const label = val;
                const backgroundColor = color[idx];
                const borderColor = color[idx];
                let currVal = 0;
                const data = [];
                if (graphType === BAR_STACKED_EQUAL_HEIGHT) {
                    entities && entities.forEach((ent) => {
                        if (graphData.hasOwnProperty(label) && graphData[label].hasOwnProperty(sentiment) && graphData[label][sentiment].hasOwnProperty(ent.entity_name)) {
                            currVal = parseData(graphData[label][sentiment][ent.entity_name][measure], true);
                        }
                        data.push(currVal);
                    });
                    set.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill, lineTension });
                } else if (graphType === PIE) {
                    if (graphData.hasOwnProperty(label) && graphData[label].hasOwnProperty(sentiment) && graphData[label][sentiment].hasOwnProperty(entity)) {
                        currVal = parseData(graphData[label][sentiment][entity][measure], true);
                    }
                    pieSet.push({ name: label, y: currVal, backgroundColor });
                }
            });
            legendSet.push({ labels: entNames, datasets: set, hcPieChartData: pieSet });
            y = x * 10;
        }
        return legendSet;
    }
}
//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataByTrend = (d = [], level, graphType, currentMeasure, entity, sentiment) => {
    if (graphType === PIE) {
        return { labels: [], datasets: [], hcPieChartData: [{}] };
    }
    const result = d;
    const dataObj = result && result[result.sequence[0]].returnData;
    const entities = dataObj.entities;
    const graphData = dataObj.graphdata;
    const journalits = dataObj.journalist;
    const keywords = dataObj.keywords;
    const publications = dataObj.publications;
    const editions = dataObj && dataObj.states;
    let measure = currentMeasure;
    const color = entities && getRandomUniqueColor(entities.length);
    const datasets = [];
    const labels = graphData && Object.keys(graphData).sort();
    let loopData;
    let loopName;
    if (level === ENTITY) {
        loopData = entities;
        loopName = "entity_name";
    } else if (level === JOURNALIST) {
        loopData = journalits;
        loopName = "source_name";
    } else if (level === KEYWORD) {
        loopData = keywords;
    } else if (level === PUBLICATION) {
        loopData = publications;
        loopName = "publication";
    } else if (level === CITY) {
        loopData = editions;
        loopName = "edition";
        //console.log("Add Level HERE");
    }
    else {
        console.log("Add Level HERE");
    }
    loopData.forEach((elm, idx) => {
        const label = (level === KEYWORD || level === CITY) ? elm : elm[loopName];
        const backgroundColor = color[idx];
        const barThickness = "flex";
        const borderColor = color[idx];
        const borderWidth = 1;
        const data = [];
        const fill = false;
        const lineTension = 1;
        labels.forEach((date) => {

            if (graphData[date].hasOwnProperty(sentiment)) {
                const value = graphData[date][sentiment][label] ? parseData(graphData[date][sentiment][label][measure], true) : 0

                const currVal = value;
                data.push(currVal);
            } else if (graphData[date].hasOwnProperty(label) && graphData[date][label].hasOwnProperty(sentiment) && graphData[date][label][sentiment].hasOwnProperty(entity)) {
                const value = graphData[date][label][sentiment] ? parseData(graphData[date][label][sentiment][entity][measure], true) : 0

                const currVal = value;
                data.push(currVal);
            }
            else {
                data.push(0);
            }
        });
        datasets.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill, lineTension });
    });
    return { labels, datasets };
}

const parseData = (value, float = false) => {
    let return_value = (float) ? Math.round(parseFloat(value * 100, 10)) / 100 : parseInt(value, 10);
    if (Number.isNaN(return_value)) {
        let newevalue = value.replace(/,/g, '')
        newevalue = (float) ? Math.round(parseFloat(newevalue * 100, 10)) / 100 : parseInt(newevalue, 10)
        return newevalue;
    }
    return return_value;
}
